<template>
  <span class="i-lucide-asterisk size-3 text-primary" />
</template>
